//
//
//
//

export default {
  name: 'Preloader',
  data() {
    return {
      isPreloaderActive: true,
    }
  },
  mounted() {
    setTimeout(() => {
      this.isPreloaderActive = false
    }, 10 * 1000)
    this.$nextTick(() => {
      window.addEventListener('load', () => {
        this.isPreloaderActive = false
      })
    })
  },
}
